import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { TitleStyle } from "./title-styles";
import { useTranslation } from "react-i18next";
export var Title = function (_a) {
    var title = _a.title;
    var t = useTranslation(['titles']).t;
    return (_jsx(React.Fragment, { children: _jsx(TitleStyle, { className: "page-header", children: _jsx("h1", { children: t(title) }) }) }));
};
